module.exports = __webpack_public_path__ + "img/security.4aed324a.webp";